import Vue from 'vue';
import store from '../store/store';

export default Vue.directive('select', {
    bind(el, binding) {
        el.onclick = () => selectListener(binding.value);
    },
    update(el, binding) {
        el.onclick = () => selectListener(binding.value);
    }
});

function selectListener(value) {
    if (value) {
        if (Array.isArray(value)) {
            store.dispatch('toggleItems', value);
        }
        else {
            store.dispatch('toggleItem', value);
        }
    }
}


// WEBPACK FOOTER //
// ./src/directives/SelectDirective.js